// NPM Imports
import React from "react";

export default function MultiSelectRenderer(props) {
  if (props.value && props.value.length > 0) {
    const values = props.value.map(item => item.name).join();
    return <div>{values}</div>;
  }
  return <div>{props.value}</div>;
}



// WEBPACK FOOTER //
// ./src/components/AgGridCellRenderer/MultiSelectRenderer.js